
class RefreshTokenManager {
  private refreshPromise: Promise<any> | null = null;
  private isRefreshing = false;

  async refreshToken(): Promise<any> {
    if (this.isRefreshing && this.refreshPromise) {
      return this.refreshPromise;
    }

    const { store } = await import('@store/store');
    const { refreshTokenOperation } = await import('@store/auth/auth-operations');

    this.isRefreshing = true;
    this.refreshPromise = store.dispatch(refreshTokenOperation()).unwrap();

    try {
      return await this.refreshPromise;
    } catch (error) {
      await import('@utils/clearPersistAndStore').then(m => m.clearPersistAndStore());
      window.location.replace('/signin');
      throw error;
    } finally {
      this.isRefreshing = false;
      this.refreshPromise = null;
    }
  }
}

export const refreshTokenManager = new RefreshTokenManager();
